<div class="lg flex h-17 w-full justify-between px-3 md:h-22">
    @if (navigationService.isSidenavActive()) {
        <button
            mat-icon-button
            class="text-shrl-blue-500! my-auto h-14! w-14!"
            (click)="sidenavToggle()"
            onclick="this.blur()"
            aria-label="Toggle Navigation">
            <mat-icon class="h-8! w-8! text-3xl">menu</mat-icon>
        </button>
    }
    <div #leftContainer class="flex pl-2">
        <a
            href="https://sharelock.pro/"
            aria-label="logo"
            class="logo-container">
            <img
                class="h-full w-40 py-3 pr-5 md:py-5"
                src="/assets/images/logo-full.png"
                alt="logo" />
        </a>
    </div>
    <!-- EMPTY SPACE -->
    <div #emptySpaceCointainer class="grow"></div>

    <!-- RIGHT CONTAINER -->
    <div #navigationButtonsContainer class="flex">
        @if (navigationService.isSidenavActive() === false) {
            <div class="">
                <shrl-top-bar-navigation-buttons
                    class="flex h-full flex-nowrap">
                </shrl-top-bar-navigation-buttons>
            </div>
        }
    </div>
    <div #profileButtonsContainer class="flex">
        @if (navigationService.isProfileButtonsInTopbarVisible()) {
            <shrl-language-button
                [isHorizontal]="true"
                class="mr-2"></shrl-language-button>
            <shrl-account-buttons [isHorizontal]="true" class="my-auto">
            </shrl-account-buttons>
        }
    </div>
</div>
